// DOM shell of the bottom-right chat drawer the web-app entry mounts SignupFlow into. Built
// here (not in the entry) so its accessibility contract is unit-tested: it has no backdrop,
// yet it must be announced as a dialog and receive keyboard focus when it opens.
export interface SignupDrawerElements {
  drawer: HTMLDivElement
  closeButton: HTMLButtonElement
  mount: HTMLDivElement
  /** Moves keyboard focus into the dialog (its close button); call once the drawer is attached. */
  focusIn: () => void
}

export function buildSignupDrawer(
  { label = 'Inscription', closeLabel = 'Fermer' }: { label?: string; closeLabel?: string } = {},
): SignupDrawerElements {
  const drawer = document.createElement('div')
  drawer.className = 'signup-drawer'
  drawer.setAttribute('role', 'dialog')
  drawer.setAttribute('aria-modal', 'true')
  drawer.setAttribute('aria-label', label)

  const closeButton = document.createElement('button')
  closeButton.type = 'button'
  closeButton.className = 'signup-drawer__close'
  closeButton.setAttribute('aria-label', closeLabel)
  closeButton.textContent = '✕'

  const mount = document.createElement('div')
  drawer.append(closeButton, mount)

  return { drawer, closeButton, mount, focusIn: () => closeButton.focus() }
}
